import { StrictMode } from 'react';
import * as ReactDOMClient from 'react-dom/client';
import * as Sentry from '@sentry/react';
import App from './App';
import { UIContextContainer } from './components/UI/UIContext';
import { getEnv } from '@reportdev-datalake/core-lib/env';

const env = getEnv();

import './i18n';

Sentry.init({
  dsn: env.APP_DSN_SENTRY,
  integrations: [Sentry.browserTracingIntegration()],
  // Performance Monitoring
  tracesSampleRate: 1.0, // Capture 100% of the transactions
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: [env.PUBLIC_URL ?? ''],
  enabled: ['development', 'test'].indexOf(env.NODE_ENV ?? '') === -1,
});

const container = document.getElementById('app');
const root: any = ReactDOMClient.createRoot(container!);

root.render(
  <StrictMode>
    <UIContextContainer>
      <App />
    </UIContextContainer>
  </StrictMode>
);
